import {Component, Input, OnInit} from '@angular/core';
import {DiscountBenefit, BenefitSelection, Cart, DiscountBenefitType} from "../../../../common";

@Component({
  selector: 'discount-benefit',
  standalone: false,
  template: `
    <div *ngIf="isFreeItem && !pastTense" i18n>get a free {{item}}</div>
    <div *ngIf="isFreeItem && pastTense" i18n>free {{item}}</div>
    <div *ngIf="isSelection && !pastTense" i18n>get a free item from {{group}}</div>
    <div *ngIf="isSelection && pastTense" i18n>free item from {{group}}</div>
  `
})

export class DiscountBenefitComponent implements OnInit {
  @Input() cart: Cart;
  @Input() benefit: DiscountBenefit;
  @Input() index: number;
  @Input() selections: Map<string, BenefitSelection>;
  @Input() pastTense: boolean = false;

  isAmount: boolean = false;
  amount: number;
  isFreeItem: boolean = false;
  item: string;
  isSelection: boolean = false;
  group: string;
  hasSelection: boolean = false;
  selection: BenefitSelection;

  ngOnInit(): void {

    this.selection = this.cart.benefitSelections.get(this.benefit.id.toString() + '-' + this.index.toString());

    switch(this.benefit.type) {
      case DiscountBenefitType.Fixed:
      case DiscountBenefitType.Percentage:
      case DiscountBenefitType.PercentageFromGroup:
        // if that happens it's a bug
        console.error("monetary benefit set in <discount-benefit>");
        // this.isAmount = true;
        // this.amount = this.benefit.getAmount(this.cart);
        break;
      case DiscountBenefitType.FreeItem:
        this.isFreeItem = true;
        if (this.selection && this.selection.isComplete()) {
          this.item = this.selection.getName();
          this.hasSelection = true;
        } else {
          this.item = this.benefit.item.name;
        }
        break;
      case DiscountBenefitType.FreeItemFromGroup:
        if (this.selection && this.selection.isComplete()) {
          // a bit hacky, but display only
          this.isFreeItem = true;
          this.item = this.selection.getName();
          this.hasSelection = true;
        } else {
          this.isSelection = true;
          this.group = this.benefit.group.name;
        }
        break;
    }
  }
}
